import lrSelect from './_src/lrSelect.vue'

lrSelect.install = function(Vue) {
  Vue.component(lrSelect.name, lrSelect)
}

export default lrSelect